import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
interface CountdownTimerProps {
  initialMinutes?: number;
  initialSeconds?: number;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}
export function CountdownTimer({
  initialMinutes = 8,
  initialSeconds = 33,
  className = '',
  size = 'md'
}: CountdownTimerProps) {
  const [time, setTime] = useState({
    minutes: initialMinutes,
    seconds: initialSeconds
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTime(prev => {
        if (prev.minutes === 0 && prev.seconds === 0) {
          return {
            minutes: initialMinutes,
            seconds: initialSeconds
          };
        }
        if (prev.seconds === 0) {
          return {
            minutes: prev.minutes - 1,
            seconds: 59
          };
        }
        return {
          ...prev,
          seconds: prev.seconds - 1
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [initialMinutes, initialSeconds]);
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  const sizeClasses = {
    sm: 'text-lg',
    md: 'text-2xl',
    lg: 'text-4xl md:text-5xl'
  };
  return <div className={`flex items-center justify-center font-bold font-mono text-amber-500 ${sizeClasses[size]} ${className}`} data-id="element-65">
      <Clock className={`mr-2 ${size === 'lg' ? 'w-8 h-8 md:w-10 md:h-10' : 'w-5 h-5'}`} data-id="element-66" />
      <span data-id="element-67">
        {formatNumber(time.minutes)} : {formatNumber(time.seconds)}
      </span>
    </div>;
}